// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-table__progress[data-v-69f1446b]{height:4px;border-bottom:1px solid #c8c8d4}", ""]);
// Exports
module.exports = exports;
